import { Draw, Modify } from 'ol/interaction';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { nanoid } from 'nanoid';
import { Collection } from 'ol';
export var CustomInteractionType;
(function (CustomInteractionType) {
    CustomInteractionType[CustomInteractionType["DRAW"] = 0] = "DRAW";
    CustomInteractionType[CustomInteractionType["EDIT"] = 1] = "EDIT";
})(CustomInteractionType || (CustomInteractionType = {}));
export class BaseCustomInteraction {
    constructor(name, type, options = {}) {
        this.id = null;
        this.interaction = null;
        this.listeners = {};
        this.customMap = null;
        this.name = name;
        this.type = type;
        this.options = {
            ...{
                style: null,
                layer: null,
                geometry: 'Point',
                // custom features object to edit
                customFeaturesToEdit: null,
            },
            ...options,
        };
        if (this.options.layer === null) {
            const source = new VectorSource();
            this.options.layer = new VectorLayer({ source });
        }
    }
    end() {
        if (this.customMap && this.id) {
            this.customMap.removeInteraction(this.id);
        }
    }
    on(type, callback) {
        if (typeof this.listeners[type] == 'undefined') {
            this.listeners[type] = [];
        }
        this.listeners[type].push(callback);
    }
    off(type, callback) {
        if (typeof this.listeners[type] != 'undefined') {
            this.listeners[type] = this.listeners[type].filter((l) => l !== callback);
        }
    }
    _handle(customMap, id) {
        this.customMap = customMap;
        this.id = id;
        let _ = this;
        if (!this.options.layer) {
            throw new Error('There is no layer assigned to that interaction.');
        }
        if (!this.options.layer.getSource()) {
            throw new Error('Assigned layer has no source.');
        }
        switch (this.type) {
            case CustomInteractionType.DRAW:
                this.interaction = new Draw({
                    source: this.options.layer.getSource(),
                    type: this.options.geometry,
                    style: this.options.style,
                });
                this.interaction.on('drawend', function ({ feature }) {
                    // generate id
                    feature.setId(nanoid());
                    _._trigger('end', { feature });
                });
                this.interaction.on('drawstart', function () {
                    _._trigger('start');
                });
                customMap.ol.addInteraction(this.interaction);
                break;
            case CustomInteractionType.EDIT:
                this.interaction = new Modify({
                    style: this.options.style,
                    features: new Collection(this.options.customFeaturesToEdit
                        ? this.options.customFeaturesToEdit.features
                        : []),
                });
                this.interaction.on('modifyend', function ({ features }) {
                    _._trigger('end', { features });
                });
                customMap.ol.addInteraction(this.interaction);
                break;
        }
    }
    _handleRemove() {
        if (this.customMap && this.interaction) {
            this.customMap.ol.removeInteraction(this.interaction);
        }
    }
    _trigger(type, data = {}) {
        if (typeof this.listeners[type] != 'undefined') {
            for (let listener of this.listeners[type]) {
                listener(data, () => {
                    this.off(type, listener);
                });
            }
        }
    }
}
